import { Component, ojs, app, v, component } from "modular-openscriptjs";
import { formatThousand } from "../../helpers";
import { uc } from "../../declarations";
import { $e } from "../../ojs.events";

const h = app("h");

export default class AiCreditCard extends Component {
    balancedFetched = false;

    render() {
        return h.div(
            {
                class: "card border-0 rounded-4 shadow-lg mb-4 ai-gradient-bg text-white position-relative overflow-hidden hover-scale",
                style: "cursor: pointer;",
                onclick: h.func("app('router').to", "user.ai-credits"),
            },
            // Decorative shapes
            h.div({
                class: "position-absolute rounded-circle",
                style: "width: 150px; height: 150px; background: rgba(255,255,255,0.08); top: -40px; right: -20px; filter: blur(5px); pointer-events: none;",
            }),
            h.div({
                class: "position-absolute rounded-circle",
                style: "width: 200px; height: 200px; background: rgba(0,0,0,0.04); bottom: -100px; left: -50px; filter: blur(4px); pointer-events: none;",
            }),
            h.div(
                {
                    class: "card-body p-4 position-relative z-1 d-flex flex-column gap-3",
                },
                h.div(
                    {
                        class: "d-flex align-items-center justify-content-between",
                    },
                    h.div(
                        { class: "d-flex align-items-center gap-3" },
                        h.div(
                            {
                                class: "glass-panel text-white circle p-2 d-flex align-items-center justify-content-center shadow-sm ai-float",
                                style: "width: 50px; height: 50px;",
                            },
                            h.i({ class: "bi bi-robot fs-4" }),
                        ),
                        h.div(
                            h.h5({ class: "mb-0 fw-bold" }, "AI Power Hub"),
                            h.p(
                                {
                                    class: "mb-0 text-white opacity-75 small fw-medium",
                                },
                                "Unlock voice ordering, image scanning, custom items, and more",
                            ),
                        ),
                    ),
                    // Desktop Action
                    h.button(
                        {
                            class: "btn btn-light rounded-pill px-4 py-2 fw-bold shadow-sm d-none d-md-block transition-all",
                            style: "color: #973e87;",
                            listeners: {
                                click: (e) => {
                                    e.stopPropagation();
                                    app("router").to("user.ai-credits");
                                },
                            },
                        },
                        "Manage",
                    ),
                ),
                h.div(
                    {
                        class: "d-flex align-items-end justify-content-between mt-2 pt-2 border-top border-white border-opacity-10",
                    },
                    h.div(
                        h.span(
                            {
                                class: "text-white opacity-75 text-uppercase fw-semibold",
                                style: "font-size: 0.75rem; letter-spacing: 1px;",
                            },
                            "Available Credits",
                        ),
                        v(uc.aiCredit, (wallet) =>
                            h.div(
                                {
                                    class: "d-flex align-items-baseline gap-1 mt-1",
                                },
                                h.h2(
                                    { class: "mb-0 fw-bold" },
                                    formatThousand(wallet.value?.balance ?? 0),
                                ),
                                h.span(
                                    {
                                        class: "opacity-75 small fw-medium text-uppercase",
                                    },
                                    " CR",
                                ),
                            ),
                        ),
                    ),
                    // Mobile Action
                    h.button(
                        {
                            class: "btn btn-light btn-sm rounded-pill px-4 py-2 fw-bold shadow-sm d-block d-md-none",
                            style: "color: #973e87;",
                            listeners: {
                                click: (e) => {
                                    e.stopPropagation();
                                    app("router").to("user.ai-credits");
                                },
                            },
                        },
                        "Manage",
                    ),
                ),
            ),
        );
    }

    $_mounted(componentId) {
        let cmp = component(componentId);

        if (cmp && !cmp.balancedFetched) {
            app("broker").send($e.aiCredit.needs.balance);
            cmp.balancedFetched = true;
        }
    }
}

ojs(AiCreditCard);
